import React from "react";
import type { DeficiencyDrawerName } from "@features/deficiencies/hooks/useDeficiencyFlow";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import ApproveDeficiency from "./ApproveDeficiency";
import ClaimDeficiency from "./ClaimDeficiency";
import RejectDeficiency from "./RejectDeficiency";
import ResolveDeficiencyButton from "./ResolveDeficiencyButton";
import UnclaimDeficiency from "./UnclaimDeficiency";
import { canResolveDeficiency, type DeficiencyFlowData } from "./utils";

interface DeficiencyFlowButtonsProps {
  deficiencyFlowData?: DeficiencyFlowData;
  openDrawer: (drawerName: DeficiencyDrawerName, deficiencyId?: string) => void;
  onClaim?: () => void;
  onUnclaim?: () => void;
  onApprove?: () => void;
  onReject?: () => void;
}

const EMPTY_ROLES: string[] = [];

const DeficiencyFlowButtons: React.FC<DeficiencyFlowButtonsProps> = ({
  deficiencyFlowData,
  openDrawer,
  onClaim,
  onUnclaim,
  onApprove,
  onReject,
}) => {
  const userRoles = useAuthStore((state) => state.user?.roles ?? EMPTY_ROLES);
  const canResolve = canResolveDeficiency(deficiencyFlowData?.status, userRoles);

  if (!canResolve && !deficiencyFlowData?.task) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-4">
      <UnclaimDeficiency deficiencyFlowData={deficiencyFlowData} onUnclaim={onUnclaim} />
      <RejectDeficiency deficiencyFlowData={deficiencyFlowData} onReject={onReject} />
      <ApproveDeficiency deficiencyFlowData={deficiencyFlowData} onApprove={onApprove} />
      <ClaimDeficiency deficiencyFlowData={deficiencyFlowData} onClaim={onClaim} />
      <ResolveDeficiencyButton
        isActionAvailable={canResolve}
        onResolve={() => openDrawer("resolveDrawer", deficiencyFlowData?.id)}
      />
    </div>
  );
};

export default DeficiencyFlowButtons;
